import { post, get, patch } from "../helpers/config";
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { IHotelAndAirbnb } from "../types/hotelandairbnb";

export const useFetchProperty = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        const response = await get("property/list?searchFilter=" + data.searchFilter);
        return response.data;
    }, options);
};

export const useAddProperty = (options?: UseMutationOptions<any, any, IHotelAndAirbnb, any>) => {
     return useMutation(async (data: any) => {
          const formattedData = {
                propertyPlaceID: data.propertyPlaceID ?? "00000000-0000-0000-0000-000000000000",
                propertyTitle: data.propertyTitle,
                featuredImageUrl: data.featuredImageUrl,
                cityID: data.cityID,
                countryID:data.countryID,
                description: data.description,
                bedrooms:data.bedrooms,
                bathrooms: data.bathrooms,
                beds: data.beds,
                guestCapacity: data.guestCapacity,
                amenities: data.amenities,
                checkInTime: data.checkInTime,
                checkOutTime: data.checkOutTime,
                mapLocations: data.mapLocations,
                contactInfo: data.contactInfo,
                houseRules: data.houseRules,
                cTA_Label: data.cTA_Label,
                cTA_Link: data.cTA_Link,
                accommodationTypeID: data.accommodationTypeID,
                galleryImageUrl: data.galleryImageUrl
             }
        return await post("property/add", formattedData);
    }, options);
};

export const useDeleteProperty = (options: any) => {
    return useMutation(async (propertyPlaceID) => {
        const response = await patch(`property/${propertyPlaceID}/delete`, {});
        return response.data;
    }, options);
};

export const useUpdateStatusProperty = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data:any) => {
        const response = await patch(`property/${data.propertyPlaceId}/${data.isActive}/update-status`, {});
        return response.data;
    }, options);
};

